import { NativeResources } from '@ariksa/abac/api';
import { ContextType } from '@ariksa/inventory-core';

import CriticalData from 'components/Icons/MapIcons/coloredIcons/sensitive data - 128x128.png';

import { IconTypes } from '../types';

import Bucket from './coloredIcons/bucket.png';
import Credential from './coloredIcons/credential.png';
import CrossAccount from './coloredIcons/cross-account.png';
import Permissions from './coloredIcons/excess-permissions.png';
import Exploitable from './coloredIcons/exploitable-vulnerability-red-128x128.png';
import Folder from './coloredIcons/folder.png';
import InternetAccessibleIcon from './coloredIcons/internet-exposure-red-128x128.png';
import ExposedCredentials from './coloredIcons/Kms-Key-Black-128x128.png';
import Malicious from './coloredIcons/malicious-activity-red-128x128.png';
import ResourcePolicy from './coloredIcons/policy-green.png';
import HighPrivileges from './coloredIcons/privileged.png';
import Unencrypted from './coloredIcons/unencrypted-data-orange-128x128.png';
import Vulnerability from './coloredIcons/vulnerability-red-128x128.png';
import BruteForceAttack from './purpleIcons/brute-force-attack-purple.png';

export const getColoredIcons = (icon: string) => {
  switch (icon) {
    case ContextType.CredentialFound:
      return ExposedCredentials;
    case ContextType.UnencryptedDisk:
      return Unencrypted;
    case ContextType.InternetAccess:
    case ContextType.InternetAccessWide:
    case ContextType.InternetAccessLimited:
      return InternetAccessibleIcon;
    case ContextType.BruteForceAttack:
      return BruteForceAttack;
    case ContextType.CriticalVulnerability:
    case ContextType.HighVulnerability:
    case ContextType.CriticalHighVulnerability:
      return Vulnerability;
    case ContextType.SensitiveData:
    case ContextType.Unencrypted:
      return CriticalData;
    case ContextType.ExcessPermissions:
      return Permissions;
    case ContextType.Privileged:
      return HighPrivileges;
    case ContextType.CrossAccount:
      return CrossAccount;
    case ContextType.MaliciousIngress:
      return Malicious;
    case ContextType.Exploitable:
      return Exploitable;
    //case NativeResources.GcpBucket:
    case NativeResources.SimpleStorageService:
      return Bucket;
    case NativeResources.ResourcePolicy:
      return ResourcePolicy;
    case IconTypes.S3Folder:
      return Folder;
    case NativeResources.IamUserAccessKey:
      return Credential;
    default:
      return '';
  }
};
